/* global axios */
import ApiClient from './ApiClient';

class OnboardingAPI extends ApiClient {
  constructor() {
    super('onboarding', { accountScoped: true });
  }

  update(params) {
    return axios.patch(this.url, { onboarding: params });
  }

  complete() {
    return axios.post(`${this.url}/complete`);
  }

  getCompletionTasks() {
    return axios.get(`${this.url}/completion_tasks`);
  }

  retryCompletionTask(id) {
    return axios.patch(`${this.url}/completion_tasks/${id}/retry`);
  }
}

export default new OnboardingAPI();
